module.exports = __webpack_public_path__ + "img/SL410BT.853.a09d8a08.png";